module.exports = __webpack_public_path__ + "7b065e9275629e28ed924b8b89cdcbdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_xlarge_x1_variable/public/picture/Chinese_0.jpg
// module id = 482
// module chunks = 0